//import React, { useEffect, useState, useContext, useRef, useMemo, useCallback } from 'react';
import React, { useEffect, useState, useContext, useRef, useMemo, useCallback, useLayoutEffect } from 'react';
import './Components.css';
import DataGrid from 'react-data-grid';
// import 'react-data-grid/lib/styles.css';
import './custom/rdgstyles.css';
import { MasterCapabilitiesList, LMList } from '../utils/LMConstants';
import ShotListHeader from './custom/ShotListHeader';
import ShotListSelectHeader from './custom/ShotListSelectHeader';
import { formatShotData, getColorFromGradient, getAllMeasurementsForLMInfo, isValidRobotTestDataField } from '../utils/Utilities';
import { LoadSession, GetCurrentSession, SetCurrentSession, CurrentSessionHasBallSeries, CurrentSessionIsSoundSession, UpdateShotCheck, UpdateCurrentSession, DeleteShotFromSession, MoveShotFromToSetup, CheckAllShots, CopyShotInSetup } from '../isdlData/sessionData';
import { AppContext, ViewOnlyContext, ThemeContext } from '../contexts/AppContext';
import { session_update } from '../mobile/mobileHandler';
import ShotListContextMenu from './ShotListContextMenu';
import DeleteShot from './DeleteShot';
import MoveShot from './MoveShot';
import { Modal, Switch } from '@mui/material';
import ShotListHeaderContextMenu from './ShotListHeaderContextMenu';
import { SoundSpeaker } from '../icons/Icons';
import { useAppStateService } from '../contexts/AppState';
import { GetUserShotlistColumnDirection, GetUserShotlistColumnFavorites, GetUserShotlistColumnOrder, SetUserShotlistColumnDirection, SetUserShotlistColumnFavorites, SetUserShotlistColumnOrder } from '../isdlData/matrixUserData';

const shotListScrollPositions = new Map();
const SETUP_TOLERANCE_FIELDS = {
  ImpactAttackAngleDeg: { targetKey: 'AttackTarget', toleranceKey: 'AttackTolerance' },
  ImpactPathAngleDeg: { targetKey: 'PathTarget', toleranceKey: 'PathTolerance' },
  FaceToPath: { targetKey: 'FaceToPathTarget', toleranceKey: 'FaceToPathTolerance' },
  ImpactPitchAngleDeg: { targetKey: 'DynamicLoftTarget', toleranceKey: 'DynamicLoftTolerance' },
  ImpactRollAngleDeg: { targetKey: 'DynamicLieTarget', toleranceKey: 'DynamicLieTolerance' }
};
const SETUP_TOLERANCE_KEYS = Object.keys(SETUP_TOLERANCE_FIELDS);
const SETUP_TOLERANCE_GOOD = 'rgba(46, 204, 113, 0.45)';
const SETUP_TOLERANCE_BAD = 'rgba(229, 57, 53, 0.45)';
const SHOTLIST_COLUMNS_ORDER_EVENT = 'shotlist-columns-order-updated';
const SHOTLIST_FAVORITES_EVENT = 'shotlist-favorites-updated';
const SHARED_COLUMNS_ORDER_KEY = 'shotListColumnsOrder';
const getLegacyColumnsOrderKey = (setupId) =>
  setupId ? `shotListColumnsOrder_${setupId}` : null;

export function ShotList({ currentSetup, onHorizontalViewportReady, setShot, inSelectedShot, handleShotChange, replacingShot, setReplacingShot, showFavoritesOnly, onFavoritesToggle, displayFavoritesControls = true, justAvSt = false, ShowAllSetups = false,hideHeaderCheckbox = false, ShowDetailedSummary = false, onShotsChanged }) {  const [selectedSetup, setSetup] = useState(null);
  const [selectedShot, setSelectedShot] = useState(null);
  const [shotlistColumns, setShotlistColumns] = useState([]);
  const [shotlistRows, setShotListRows] = useState([]);
  const [useSeries, SetUseSeries] = useState(false);
  const [summaryColumns, SetSummaryColumns] = useState([]);
  const [deleteShotModal, setDeleteShotModalState] = useState(false);
  const [moveShotModal, setMoveShotModalState] = useState(false);
  const [sortColumns, setSortColumns] = useState([]);

  const appState = useAppStateService();
  const { viewOnly } = useContext(ViewOnlyContext);
  const { theme, setAppTheme } = useContext(ThemeContext);

  const divRef = useRef(null);
  const dataGridRef = useRef(null);
  const lastScrollLeftRef = useRef(0);
  const [contextMenu, showContextMenu] = useState(false);
  const [contextMenuData, setContextMenuData] = useState({ x: 0, y: 0 });

  const [columnContextData, setColumnContextData] = useState(null);
  const [columnContextDataExists, setColumnContextDataExists] = useState(false);
  const [columnContextMenu, showColumnContextMenu] = useState(false);
  const [columnContextMenuData, setColumnContextMenuData] = useState({ x: 0, y: 0 });
  const [columnsOrderVersion, setColumnsOrderVersion] = useState(0);
  const [favoritesVersion, setFavoritesVersion] = useState(0);

  const handleContextMenuClose = useCallback(() => {
    showContextMenu(false);
    showColumnContextMenu(false);
  }, [showContextMenu, showColumnContextMenu]);
  
  const handleColumnContextMenuClose = useCallback(() => {
    showColumnContextMenu(false);
    setColumnContextData(null);
  }, []);
  let touchMovePos = {x:0, y:0};

  const [currentTheme, setCurrentTheme] = useState(theme);

  const [localFavoritesOnly, setLocalFavoritesOnly] = useState(false);
  const isFavoritesControlled = typeof showFavoritesOnly === "boolean";
  const effectiveFavoritesOnly = isFavoritesControlled ? showFavoritesOnly : localFavoritesOnly;

  const favorites = useRef([]);

  let contextMenuReady = false;
  const applyFavoritesFilter = useCallback((value = false) => {
    if (typeof onFavoritesToggle === "function") {
      onFavoritesToggle(value);
    }
    if (!isFavoritesControlled) {
      setLocalFavoritesOnly(value);
    }
    saveFavorites({ favoriteSelected: value });
  }, [onFavoritesToggle, isFavoritesControlled]);



  let touchTimeout = null; // To track the hold duration
  const holdDuration = 500; // Duration in ms to simulate a right-click

  var shotListLoaded = false;

  // ─── LOAD/UPDATE THE SETUP ────────────────────────────────────────────
  useEffect(() => {
    SetUseSeries(CurrentSessionHasBallSeries());
    SetSummaryColumns([]);

    if ((currentSetup && !shotListLoaded)||ShowAllSetups) {
      setShotListRows([]);
      setSetup(currentSetup);
      updateColumns();
      updateRows();

      if (inSelectedShot) {
        setSelectedShot(inSelectedShot);
      }else{
        setSelectedShot(null);
      }

      shotListLoaded = true;
    }

    if (currentSetup === null) {
      setShotListRows([]);
      setSetup(null);
      updateColumns();
      updateRows();
    }

    // Also, when a new setup loads, try to load the saved ShotNumber sort order.
    if (currentSetup) {
      // const savedSort = localStorage.getItem('shotNumberSortOrder');
      (async () => {
        const savedSort = await GetUserShotlistColumnDirection();
        if (savedSort) {
          setSortColumns(savedSort);
        }
      })();
    }

    return () => {};
  }, [currentSetup, inSelectedShot, effectiveFavoritesOnly, columnsOrderVersion, favoritesVersion]);

  useEffect(() => {
    loadFavorites();

    document.addEventListener('scroll', handleDataGridScroll, { capture: true });
    return () => {
      document.removeEventListener('scroll', handleDataGridScroll, { capture: true });
    };
  }, []);

  useEffect(() => {
    setCurrentTheme(theme);
  }, [theme]);

  useEffect(() => {
    const handleColumnsOrderUpdated = () => {
      setColumnsOrderVersion(prev => prev + 1);
    };
    const handleFavoritesUpdated = () => {
      loadFavorites();
      setFavoritesVersion(prev => prev + 1);
    };

    window.addEventListener(SHOTLIST_COLUMNS_ORDER_EVENT, handleColumnsOrderUpdated);
    window.addEventListener(SHOTLIST_FAVORITES_EVENT, handleFavoritesUpdated);
    return () => {
      window.removeEventListener(SHOTLIST_COLUMNS_ORDER_EVENT, handleColumnsOrderUpdated);
      window.removeEventListener(SHOTLIST_FAVORITES_EVENT, handleFavoritesUpdated);
    };
  }, []);

  useEffect(() => {
    if (replacingShot === null) {
      updateColumns();
      updateRows();
    }
    setReplacingShot(replacingShot);
  }, [replacingShot]);

  useEffect(() => {
    updateColumns();
  }, [summaryColumns])

  useEffect(() =>{
      updateRows();
  }, [ShowDetailedSummary, justAvSt])






  // ─── BUILDING THE COLUMNS ─────────────────────────────────────────────
  // We build a fresh list of columns and then, if a cache exists,
  // reorder them according to the cached order.
  async function updateColumns() {
    // Start with your default (static) columns.
    let columns = [
      {
        key: 'ShotNumber',
        name: '#',
        width: 40,
        minWidth: 40,
        resizable: false,
        frozen: true,
        sortable: true,
        draggable: false,
        renderSummaryCell({row}) {
          return <div className="datagrid-summary-container">{row?.type || "--"}</div>;
        }
      },
      // Add additional static columns as needed...
    ];

    // Add the "IsSelected" column if not already added.
    const hasIsSelectedAlready = columns.some(obj => obj.key === 'IsSelected');
    if (!hasIsSelectedAlready) {
      columns.push({
        key: 'IsSelected',
        name: '',
        width: 35,
        minWidth: 35,
        maxWidth: 35,
        resizable: false,
        frozen: true,
        sortable: false,
        draggable: false,
        renderHeaderCell() {
          return <ShotListSelectHeader headerClicked={handleCheckHeaderClick} show={!ShowAllSetups} />;
        },
        renderCell: CustomCheckedCellRenderer,
        renderSummaryCell({row}) {
          return <div className="datagrid-summary-container">{row?.type === "Avg" ? getCheckedShotCount() : "±"}</div>;
        }
      });
    }

    // Add the "Group" column if the session has ball series.
    const hasSeries = CurrentSessionHasBallSeries();
    SetUseSeries(hasSeries);
    if (hasSeries) {
      const groupValues = Array.isArray(currentSetup?.Shots)
        ? currentSetup.Shots
            .map((shot) => (shot?.Group === null || shot?.Group === undefined ? '' : String(shot.Group)))
        : [];
      const longestGroupLength = groupValues.reduce((maxLength, value) => Math.max(maxLength, value.length), 'Group'.length);
      const groupColumnWidth = Math.min(360, Math.max(80, longestGroupLength * 8 + 24));

      columns.push({
        key: 'Group',
        name: 'Group',
        width: groupColumnWidth,
        minWidth: groupColumnWidth,
        resizable: false,
        frozen: true,
        sortable: false,
        draggable: false,
      });
    }

    const hasSoundSession = CurrentSessionIsSoundSession();
    if (hasSoundSession) {
      columns.push({
        key: 'Sound',
        name: '',
        width: 35,
        minWidth: 35,
        resizable: false,
        frozen: true,
        sortable: false,
        draggable: false,
        renderCell: CustomSoundCellRenderer,
      });
    }

    // If there's no setup or shots, use the static columns.
    if (!currentSetup || !currentSetup.Shots) {
      setShotlistColumns(columns);
      return;
    }

    // Gather unique dynamic measurement columns.
    let shotColumnsToAdd = [];
    for (let i = 0; i < currentSetup.Shots.length; i++) {
      const shot = currentSetup.Shots[i];
      for (let j = 0; j < shot.LMInfos.length; j++) {
        const lminfo = shot.LMInfos[j];

        const measurements = getAllMeasurementsForLMInfo(lminfo);
        for (let key in measurements) {
          const newKey = lminfo.LMType + '$' + key;

          if(effectiveFavoritesOnly){
            const favOption = favorites.current.find(c => c === newKey);
            if((favOption === null || favOption === undefined))
            {
              continue;
            }
          }

          const exists = shotColumnsToAdd.some(item => item.mKey === newKey);
          if (!exists) shotColumnsToAdd.push({ mKey: newKey, capability: key, lmtype: lminfo.LMType });
        }
      }
    }

    // Add the dynamic measurement columns.
    for (let i = 0; i < shotColumnsToAdd.length; i++) {
      let item = shotColumnsToAdd[i];
      const masterItem = MasterCapabilitiesList.find(l => l.key === item.capability);
      if (masterItem) {
        let dispName = masterItem.display;
        let dispUnit = masterItem.unit;
        let dispColor = LMList.find(l => l.type === item.lmtype).color;
        columns.push({
          key: item.mKey,
          name: dispName,
          width: 100,
          minWidth: 100,
          resizable: false,
          sortable: true,
          draggable: true,
          renderHeaderCell: () => <ShotListHeader column={{key: item.mKey, name: dispName, unit: dispUnit }} color={dispColor} onHeaderContextMenu={handleHeaderRightClick} />,
          renderCell: CustomCellRenderer,
          renderSummaryCell: CustomSummaryCellRenderer
        });
      }
    }

    // ─── REORDER COLUMNS BASED ON CACHE ──────────────────────────────
    // If currentSetup exists (and has an Id), try to load a cached order.
    if (currentSetup && currentSetup.Id) {
      //let cachedOrderString = localStorage.getItem(SHARED_COLUMNS_ORDER_KEY);
      let cachedOrderString = JSON.stringify(await GetUserShotlistColumnOrder());
      if (!cachedOrderString) {
        const legacyKey = getLegacyColumnsOrderKey(currentSetup.Id);
        if (legacyKey) {
          cachedOrderString = localStorage.getItem(legacyKey);
        }
      }
      if (cachedOrderString) {
        try {
          // const cachedOrder = JSON.parse(cachedOrderString); // an array of column keys
          // // Reorder columns so that those in the cached order come first (in that order)
          // // and then append any new columns that were not in the cache.
          // columns = cachedOrder
          //   .map(key => columns.find(col => col.key === key))
          //   .filter(Boolean)
          //   .concat(columns.filter(col => !cachedOrder.includes(col.key)));
          const cachedOrder = JSON.parse(cachedOrderString);

          if (Array.isArray(cachedOrder)) {
            columns = cachedOrder
              .map(key => columns.find(col => col.key === key))
              .filter(Boolean)
              .concat(columns.filter(col => !cachedOrder.includes(col.key)));
          }
        } catch (e) {
          console.error('Failed to parse cached columns order', e);
        }
      }
    }
    setShotlistColumns(columns);
  }

function handleHeaderRightClick(columnKey) {
  console.log('right-clicked header:', columnKey);
  const column = document.getElementById(columnKey);

  setColumnContextMenuData({x: column.getBoundingClientRect().x, y: column.getBoundingClientRect().y})
  setColumnContextData(columnKey);
  showColumnContextMenu(true);
  showContextMenu(false);
  const favOption = favorites.current.find(c => c === columnKey);
  setColumnContextDataExists(!(favOption === null || favOption === undefined));

}

  // ─── BUILDING THE ROWS ───────────────────────────────────────────────
  function updateRows() {
    let shotRowsToAdd = [];
    let crawlingAvg = [];
    SetSummaryColumns([]);
    if (!currentSetup || !currentSetup.Shots) {
      setShotListRows(shotRowsToAdd);
      return;
    }

    const isSetup = currentSetup?.TestParameters?.RobotFaceMap?.IsSetup === true;
    const toleranceParams = isSetup
      ? GetCurrentSession()?.TestParameters?.RobotFaceMap || null
      : null;

    const evaluateShotTolerance = (shot) => {
      if (!toleranceParams) {
        return null;
      }

      const measurementMap = {};
      if (Array.isArray(shot?.LMInfos)) {
        shot.LMInfos.forEach((info) => {
          const measurements = {
            ...(info?.Measurements || {}),
            ...(info?.CalculatedMeasurements || {})
          };
          SETUP_TOLERANCE_KEYS.forEach((key) => {
            if (measurementMap[key] === undefined && measurements[key] !== undefined && measurements[key] !== null) {
              measurementMap[key] = measurements[key];
            }
          });
        });
      }

      const results = {};
      let allPass = true;
      SETUP_TOLERANCE_KEYS.forEach((key) => {
        const config = SETUP_TOLERANCE_FIELDS[key];
        const hasValidRobotTestData = isValidRobotTestDataField(toleranceParams, config.targetKey)
          && isValidRobotTestDataField(toleranceParams, config.toleranceKey);
        if (!hasValidRobotTestData) {
          return;
        }

        const value = Number(measurementMap[key]);
        const target = Number(toleranceParams[config.targetKey]);
        const tolerance = Number(toleranceParams[config.toleranceKey]);
        const hasValidInputs = Number.isFinite(value) && Number.isFinite(target) && Number.isFinite(tolerance);
        const pass = hasValidInputs && Math.abs(value - target) <= tolerance;

        results[key] = {
          pass,
          value,
          target,
          tolerance,
          hasValidInputs
        };

        if (!pass) {
          allPass = false;
        }
      });

      return { allPass, results };
    };

    const hasSeries = CurrentSessionHasBallSeries();
    const hasSoundSession = CurrentSessionIsSoundSession();
    SetUseSeries(hasSeries);
    
    for (let i = 0; i < currentSetup.Shots.length; i++) {
      shotRowsToAdd.push({});
      let shotData = shotRowsToAdd[shotRowsToAdd.length - 1];
      const shot = currentSetup.Shots[i];

      shotData.ShotNumber = shot.ShotNumber;
      shotData.IsSelected = shot.IsChecked;

      if (hasSeries) {
        shotData.Group = shot.Group;
      }

      if(hasSoundSession){
        if(shot.SoundFileUrl && shot.SoundFileUrl !== ''){
          shotData.Sound = shot.SoundFileUrl;
        }else{
          shotData.Sound = '';
        }
      }

      const toleranceResult = evaluateShotTolerance(shot);
      if (toleranceResult) {
        shotData.__setupTolerance = toleranceResult;
      }

      for (let j = 0; j < shot.LMInfos.length; j++) {
        const lminfo = shot.LMInfos[j];
        const measurements = getAllMeasurementsForLMInfo(lminfo);
        for (let key in measurements) {
          const newKey = lminfo.LMType + '$' + key;
          const value =
            measurements[key] === 'NaN'
              ? measurements[key]
              : formatShotData(key, measurements[key]);

          if (shotData.IsSelected) {
            crawlingAvg = AddItemToAvg(newKey, value, crawlingAvg);
          }
          shotData[newKey] = value;
        }
      }
    }

     if (justAvSt && !ShowDetailedSummary) {
        setShotListRows([]);
      } else {
        setShotListRows(shotRowsToAdd);
      }



    SetSummaryColumns(crawlingAvg);

    document.querySelectorAll('#shotlist_checkbox').forEach(el => {
      el.disabled = false;
    });
  }

  function AddItemToAvg(key, value, existingAvg) {
    let avgData = existingAvg;// ? existingAvg : [];
    let existingItem = avgData.find(item => item.key === key);
    const isNaNOrMissing =
      value === undefined ||
      value === null ||
      Number.isNaN(value) ||
      value === 'NaN' ||
      Number(value) === -99999;
    if (!isNaNOrMissing) {
      if (existingItem) {
        existingItem.value += Number(value);
        existingItem.count += 1;
        existingItem.values.push(Number(value));
      } else {
        avgData.push({ key: key, value: Number(value), values:[Number(value)], count: 1 });
      }
      // SetColumnAvgs(avgData);
      return avgData;
    }else{
      return existingAvg;
    }
  }

  // ─── CUSTOM CELL RENDERERS ────────────────────────────────────────────
  const CustomCellRenderer = ({ column, row }) => {
    let value = row[column.key];
    const isNaNOrMissing =
      value === undefined || value === null || Number.isNaN(value) || value === 'NaN';
    if (value === 'NaN') value = '';

    let bgColor = 'transparent';
    const [lmTypeKey, capabilityKey] = column.key.includes('$')
      ? column.key.split('$')
      : [null, null];
    const toleranceInfo = capabilityKey
      ? row?.__setupTolerance?.results?.[capabilityKey]
      : null;
    const useToleranceHighlight = !!toleranceInfo;
    const shouldHighlightResearchQuadAngle =
      lmTypeKey === 'RESEARCH_QUAD' &&
      (capabilityKey === 'post_BallLaunchAngleDeg' || capabilityKey === 'post_BallSideAngleDeg') &&
      Math.abs(Number(value)) > 4;

    if (useToleranceHighlight) {
      bgColor = toleranceInfo.pass ? SETUP_TOLERANCE_GOOD : SETUP_TOLERANCE_BAD;
    } else if (shouldHighlightResearchQuadAngle) {
      bgColor = SETUP_TOLERANCE_BAD;
    } else if (isNaNOrMissing) {
      bgColor = getComputedStyle(document.documentElement).getPropertyValue('--selected-deselected');
    } else {
      if (column.key.includes('TrackingPercentage')) {
        bgColor = getColorFromGradient(value);
      }
    }

    const style = {
      backgroundColor: bgColor,
      width: 'calc(100% + 16px)',
      height: '100%',
      transform: 'translateX(-8px)',
      alignContent: 'center'
    };

    const missingStyle = {
      backgroundColor: bgColor, // base color
      backgroundImage:
        'repeating-linear-gradient(135deg, rgba(255,255,255,0.08) 0, rgba(255,255,255,0.08) 8px, transparent 8px, transparent 16px)',
      width: 'calc(100% + 16px)',
      height: '100%',
      transform: 'translateX(-8px)',
      alignContent: 'center'
    };

    return <div style={isNaNOrMissing && !useToleranceHighlight ? missingStyle : style}>{value}</div>;
  };

    const CustomCheckedCellRenderer = ({ column, row }) => {
    const style = {
      width: '25px',
      height: '25px',
      transform: 'translate(-7px, 2px)'
    };
    return (
      <div>
        
         <input id={"shotlist_checkbox"} type="checkbox" style={style} checked={row[column.key]} onChange={handleCheckCellClick(row)} />
       
      </div>
    );
  };

  const CustomSoundCellRenderer = ({ column, row }) => {
    const style = {
      width: '35px',
      height: '35px',
      transform: 'translate(-7px, 0px)'
    };
    const soundUrl = row[column.key];
    const audioRef = useRef(null);

  const playSound = async (e) => {
    e.stopPropagation();

    if (!soundUrl) return;

    // Lazily create the Audio and avoid downloading until play.
    if (!audioRef.current) {
      const audio = new Audio();
      audio.preload = "none";   // don't download until play()
      // audio.crossOrigin = "anonymous"; // only if you need CORS (e.g., for Web Audio analysis)
      audio.src = soundUrl;     // safe to set after preload="none"
      audioRef.current = audio;
    }

    try {
      const base = audioRef.current;

      // For rapid retriggers/overlap, use a clone; otherwise reuse the base.
      const player = base.paused ? base : base.cloneNode();
      player.currentTime = 0;
      await player.play();
    } catch (err) {
      console.error("Playback failed:", err);
    }
  };

    return (
      <div style={style}>
        {soundUrl !== "" ? (
          <button onClick={playSound} style={{alignContent:'center', background:'transparent', border: '0px', margin:'0px', padding: '0px', width:'100%', height:'100%'}}>
            <SoundSpeaker width='25px' height='25px'/>
          </button>
        ) : (
          <div/>
        )}
      </div>
    );
  };

  const CustomSummaryCellRenderer = ({ column, row }) => {
    let value = summaryColumns.find(item => item.key === column.key);
    const type = row.type;
    switch(type){
      case "Avg":
        if (value) {
          let avg = value.value / value.count;
          let key = column.key.split('$')[1];
          let finalAvg = formatShotData(key, avg, true);
          return <div className="datagrid-summary-container">{finalAvg}</div>;
        } else {
          return <div className="datagrid-summary-container">--</div>;
        }
        break;
      case "Std":
        if (value && value.values && value.values.length > 1) {
          let key = column.key.split('$')[1];
          return <div className="datagrid-summary-container">{formatShotData(key,standardDeviation(value.values),true)}</div>;
        }else{
          return <div className="datagrid-summary-container">--</div>;
        }
        break;
    }
    
  };

  function standardDeviation(numbers, isSample = true) {
    let n = numbers.length;
    if (n === 0) return 0; // Prevent division by zero
    
    // Step 1: Calculate mean
    let mean = numbers.reduce((acc, val) => acc + val, 0) / n;

    // Step 2: Calculate squared differences
    let squaredDiffs = numbers.map(num => Math.pow(num - mean, 2));

    // Step 3: Calculate variance
    let variance = squaredDiffs.reduce((acc, val) => acc + val, 0) / (isSample ? n - 1 : n);

    // Step 4: Return standard deviation (sqrt of variance)
    return Math.sqrt(variance);
};

  // ─── EVENT HANDLERS ───────────────────────────────────────────────────
  const handleRowClick = row => {
    let shot = currentSetup.Shots.find(s => s.ShotNumber === row.row.ShotNumber);
    setSelectedShot(shot);
    setShot(shot);

    if (contextMenuReady) {
      showContextMenu(true);
      showColumnContextMenu(false);
      contextMenuReady = false;
    } else {
      showContextMenu(false);
      showColumnContextMenu(false);
    }

    if (replacingShot) {
      setReplacingShot(null);
    }
  };

  const handleCheckHeaderClick = async e => {
    if (!currentSetup || !currentSetup.Shots || currentSetup.Shots.length === 0) return;
    let checked = e.target.checked;

    await CheckAllShots(currentSetup, checked, !viewOnly);
    if (typeof onShotsChanged === 'function') {
      onShotsChanged();
    }
    updateRows();

    if (!viewOnly) {
      await handleShotChange();
    }

    let currentSession = GetCurrentSession();
    session_update(currentSession.id, currentSetup.Id, viewOnly);
  };

  const handleCheckCellClick = row => e => {
    handleCheckCell(e, row);
  };

  const handleCheckCell = async (e, row) => {
    e.target.disabled = true;
    let shot = currentSetup.Shots.find(s => s.ShotNumber === row.ShotNumber);
    const checked = e.target.checked;
    // shot.IsChecked = e.target.checked;

    await UpdateShotCheck(currentSetup, shot, checked, !viewOnly);
    if (typeof onShotsChanged === 'function') {
      onShotsChanged();
    }
    updateRows();

    // if (!viewOnly) {
    //   await handleShotChange();
    // }

    //   let currentSession = GetCurrentSession();
    //   session_update(currentSession.id, currentSetup.Id, viewOnly);
  };

  const generateAvgRow = (columns, rows) => {
    const summaryRow = {};
    columns.forEach(column => {
      summaryRow[column.key] = '--';
    });
    return summaryRow;
  };

  const generateStdRow = (columns, rows) => {
    const summaryRow = {};
    columns.forEach(column => {
      summaryRow[column.key] = '--';
    });
    return summaryRow;
  };

  const bottomAvgRow = [
    {type:"Avg", ...generateAvgRow(shotlistColumns, shotlistRows)}, 
    {type:"Std", ...generateStdRow(shotlistColumns, shotlistRows)}
  ];

  function getCheckedShotCount() {
    if (!currentSetup || !currentSetup.Shots || currentSetup.Shots.length === 0) return 0;
    return currentSetup.Shots.filter(shot => shot.IsChecked).length;
  }

  const handleRightClicks = e => {
    e.preventDefault();
    if (viewOnly) return;
    if((e.touches !== undefined && e.touches !== null) ) return;
    const targetElement = e.target;
    if (targetElement && typeof targetElement.click === 'function') {
      setContextMenuData({ x: e.clientX, y: e.clientY });
      contextMenuReady = true;
      targetElement.click();
    }
  };

  const handleTouchStart = e => {
    if (viewOnly) return;
    if(e.touches.length == 0) return;
    const targetElement = e.target;
    const initPos = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    touchMovePos = initPos;
    touchTimeout = setTimeout(() => {
      const nextPos = touchMovePos;
      if (targetElement && typeof targetElement.click === 'function' && getDistance(initPos, nextPos) < 30) {
        if(targetElement.id !== ''){
          //open column context menu
          handleHeaderRightClick(targetElement.id);
        }else{
          //open shot context menu
          setContextMenuData(nextPos);
          contextMenuReady = true;
          targetElement.click();
        }
      }
    }, holdDuration);
  };

  const getDistance = (p1, p2) =>
    Math.hypot(p2.x - p1.x, p2.y - p1.y);

  const handleTouchEnd = () => {
    if (touchTimeout) {
      clearTimeout(touchTimeout);
      touchTimeout = null;
    }
  };

  const handleTouchMove = e => {
    if (e.touches.length === 0) {
      return;
    }

    touchMovePos = {x:e.touches[0].clientX, y:e.touches[0].clientY};
  }

  const handleDataGridScroll = e => {
    showContextMenu(false);
    showColumnContextMenu(false);
  };
   const getDataGridElement = useCallback(() => {
    const element = dataGridRef.current;
    if (!element) {
      return null;
    }

    if (element.element) {
      return element.element;
    }

    return element;
  }, []);

  const getScrollStorageKey = useCallback(
    (setupId) => (setupId ? `setup_${setupId}` : 'default'),
    []
  );

  useLayoutEffect(() => {
    const gridElement = getDataGridElement();
    if (!gridElement) {
      return undefined;
    }

    const viewport = gridElement.querySelector('.rdg-viewport') || gridElement;
    const setupKey = getScrollStorageKey(currentSetup?.Id);
    const storedScrollLeft = shotListScrollPositions.get(setupKey) ?? 0;
    lastScrollLeftRef.current = storedScrollLeft;

    if (viewport.scrollLeft !== storedScrollLeft) {
      viewport.scrollLeft = storedScrollLeft;
    }

    const handleScroll = () => {
      lastScrollLeftRef.current = viewport.scrollLeft;
      shotListScrollPositions.set(setupKey, viewport.scrollLeft);
    };

    viewport.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      viewport.removeEventListener('scroll', handleScroll);
      shotListScrollPositions.set(setupKey, lastScrollLeftRef.current);
    };
  }, [currentSetup?.Id, shotlistColumns, getDataGridElement, getScrollStorageKey]);
  
  useLayoutEffect(() => {
    const gridElement = getDataGridElement();
    const viewport = gridElement?.querySelector('.rdg-viewport') || gridElement || null;
    const setupId = currentSetup?.Id || null;

    if (typeof onHorizontalViewportReady === 'function' && setupId && viewport) {
      onHorizontalViewportReady(setupId, viewport);
    }

    return () => {
      if (typeof onHorizontalViewportReady === 'function' && setupId) {
        onHorizontalViewportReady(setupId, null);
      }
    };
  }, [currentSetup?.Id, shotlistColumns, getDataGridElement, onHorizontalViewportReady]);
  
  const handleContextItemSelected = option => {
    showContextMenu(false);
    showColumnContextMenu(false);

    switch (option) {
      case 'DELETE':
        setDeleteShotModalState(true);
        break;
      case 'COPY':
        handleCopyShot();
        break;
      case 'REPLACE':
        setReplacingShot(selectedShot);
        break;
      case 'MOVE':
        setMoveShotModalState(true);
        break;
      default:
        break;
    }
  };

  const handleContextHeaderItemSelected = option => {

    switch(option){
      case 'ADD':
        handleAddToFavorites();
      break;
      case 'REMOVE':
        handleRemoveFromFavorites();
      break;
    }
    showContextMenu(false);
    showColumnContextMenu(false);
  }

  const handleAddToFavorites = () => {
    let curFavs = [...favorites.current];

    if(!curFavs.find(c => c === columnContextData)){
      curFavs.push(columnContextData);
    }

    favorites.current = curFavs;
    saveFavorites({favorites:curFavs});
  }

  const handleRemoveFromFavorites = () => {
    let curFavs = [...favorites.current];

    curFavs = curFavs.filter(c => c !== columnContextData);

    favorites.current = curFavs;
    saveFavorites({favorites:curFavs});
  }

  async function saveFavorites(newData = {}){
    const existingData = await GetUserShotlistColumnFavorites();
    let data = {
      favoriteSelected: existingData?.favoriteSelected ?? effectiveFavoritesOnly,
      favorites: existingData?.favorites ?? favorites.current
    };
    data = {
      ...data,
      ...newData
    };
    await SetUserShotlistColumnFavorites(data);
    window.dispatchEvent(new CustomEvent(SHOTLIST_FAVORITES_EVENT));
  }

  async function loadFavorites() {
    let data = await GetUserShotlistColumnFavorites();

    if (data === null || data === undefined) {
      favorites.current = [];
      if (!isFavoritesControlled) {
        setLocalFavoritesOnly(false);
      }
      return;
    }

    favorites.current = data.favorites ? data.favorites : [];
    const savedFavoritesSelected = !!data.favoriteSelected;
    if (!isFavoritesControlled) {
      setLocalFavoritesOnly(savedFavoritesSelected);
    }
  }

  const handleDeleteShotResult = async result => {
    setDeleteShotModalState(false);
    if (result) {
      await DeleteShotFromSession(selectedSetup.Id, selectedShot.ShotNumber);
      await handleShotChange();
    }
  };

  const handleMoveShotResult = async result => {
    setMoveShotModalState(false);
    if (result.result) {
      await MoveShotFromToSetup(currentSetup.Id, result.newSetup, selectedShot.ShotNumber);
      await handleShotChange();
    }
  };

  const handleCopyShot = async () => {
    if (!selectedSetup || !selectedShot) {
      return;
    }

    await CopyShotInSetup(selectedSetup.Id, selectedShot.ShotNumber);
    await handleShotChange();
  };

  // ─── SORTED ROWS CALCULATION ─────────────────────────────────────────
  const sortedRows = useMemo(() => {
    if (sortColumns.length === 0) return shotlistRows;
    return [...shotlistRows].sort((a, b) => {
      for (const sort of sortColumns) {
        // const aValue = a[sort.columnKey];
        // const bValue = b[sort.columnKey];
        
        const rawA = a[sort.columnKey];
        const rawB = b[sort.columnKey];

        const aValue = Number(rawA);
        const bValue = Number(rawB);

        const aIsValid = Number.isFinite(aValue);
        const bIsValid = Number.isFinite(bValue);

        if (!aIsValid && !bIsValid) continue;
        if (!aIsValid) return 1;
        if (!bIsValid) return -1;

        const comparison = aValue - bValue;

        if (comparison !== 0) {
          return sort.direction === "ASC"
            ? comparison
            : -comparison;
        }
      }
      return 0;
    });
  }, [shotlistRows, sortColumns]);
  
  useEffect(() => {
      if (!selectedShot || !dataGridRef.current) {
        return;
      }

      const rowIdx = sortedRows.findIndex(
        row => row.ShotNumber === selectedShot.ShotNumber
      );

      if (rowIdx === -1) {
        return;
      }

      if (typeof dataGridRef.current.scrollToCell === 'function') {
        dataGridRef.current.scrollToCell({ rowIdx, columnIdx: 0 });
      }
    }, [selectedShot, sortedRows]);
  // ─── HANDLE COLUMN REORDERING AND CACHE THE ORDER ──────────────────────
  const handleColumnsReorder = useCallback( async (sourceColumn, targetColumn) => {
    const sourceIdx = shotlistColumns.findIndex(col => col.key === sourceColumn);
    const targetIdx = shotlistColumns.findIndex(col => col.key === targetColumn);
    if (sourceIdx < 0 || targetIdx < 0) return;
    const sourceColumnData = shotlistColumns[sourceIdx];
    const targetColumnData = shotlistColumns[targetIdx];
    // Prevent reordering of frozen columns.
    if (sourceColumnData?.frozen || targetColumnData?.frozen) return;

    const updatedColumns = [...shotlistColumns];
    // Remove the source column and insert it at the target index.
    const [movedColumn] = updatedColumns.splice(sourceIdx, 1);
    updatedColumns.splice(targetIdx, 0, movedColumn);
    setShotlistColumns(updatedColumns);

    // Save the new order (as an array of keys) to localStorage for the session
    // so every setup shares the same column order.
    const newOrder = updatedColumns.map(col => col.key);
    // localStorage.setItem(SHARED_COLUMNS_ORDER_KEY, JSON.stringify(newOrder));

    await SetUserShotlistColumnOrder(newOrder);

    if (currentSetup?.Id) {
      const legacyKey = getLegacyColumnsOrderKey(currentSetup.Id);
      if (legacyKey) {
        localStorage.setItem(legacyKey, JSON.stringify(newOrder));
      }
    }

    window.dispatchEvent(new CustomEvent(SHOTLIST_COLUMNS_ORDER_EVENT));
  }, [shotlistColumns, currentSetup]);

  // ─── CUSTOM SORT HANDLER FOR "ShotNumber" COLUMN ──────────────────────
  const handleSortColumnsChange = async newSortColumns => {
    // setSortColumns(newSortColumns);
    // // Look for the "ShotNumber" column sort state and store it.
    // const shotNumberSort = newSortColumns.find(sc => sc.columnKey === 'ShotNumber');
    // if (shotNumberSort) {
    //   localStorage.setItem('shotNumberSortOrder', JSON.stringify(shotNumberSort.direction));
    // } else {
    //   // Optionally clear it if "ShotNumber" is no longer sorted.
    //   localStorage.removeItem('shotNumberSortOrder');
    // }
    //lets just save the direction - ND
    setSortColumns(newSortColumns);
    await SetUserShotlistColumnDirection(newSortColumns);
    contextMenuReady = false;
  };

  const handleFavCheck = (e) => {
    const newVal = e.target.checked;
    applyFavoritesFilter(newVal);
  }

  const handleFavForce = (val) => {
    applyFavoritesFilter(val);
  }

  // ─── RENDER THE COMPONENT ─────────────────────────────────────────────
  return (
    <div style={{height:'100%', width:'100%', display:'flex', flexDirection:'column'}}>
      {displayFavoritesControls && (
        <div style={{height:'40px', width:'100%', display:'flex', flexDirection:'row', justifyContent:'start', alignItems:'center'}}>
          <span onClick={() => handleFavForce(false)}>Show All</span>
          <Switch
            checked={effectiveFavoritesOnly}
            onChange={handleFavCheck}
          />
          <span onClick={() => handleFavForce(true)}>Favorites</span>
        </div>
      )}
      <div
      ref={divRef}
      style={{ height: displayFavoritesControls ? 'calc(100% - 40px)' : '100%', width: '100%' }}
      onContextMenu={handleRightClicks}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchMove={handleTouchMove}
    >
      <DataGrid
        ref={dataGridRef}
        className= {currentTheme == "dark" ? "rdg-dark" : "rdg-light"}
        style={{
          height: '100%',
          contain: 'none',
          width: '100%',
          padding: 0,
          backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--background-secondary')
        }}
        columns={shotlistColumns}
        rows={sortedRows}
        sortColumns={sortColumns}
        onSortColumnsChange={handleSortColumnsChange}
        onColumnsReorder={handleColumnsReorder}
        onCellClick={handleRowClick}
        rowClass={row =>
          replacingShot && row.ShotNumber === replacingShot.ShotNumber
            ? 'shot-replacing'
            : selectedShot && row.ShotNumber === selectedShot.ShotNumber
            ? 'shot-selected'
            : 'shot-unselected'
        }
        bottomSummaryRows={bottomAvgRow}
      />
      {contextMenu && (
        <ShotListContextMenu
          ContextLocation={contextMenuData}
          CurrentShot={selectedShot}
          HandleShotContext={handleContextItemSelected}
          onClose={handleContextMenuClose}
        />
      )}
      {columnContextMenu && (
        <ShotListHeaderContextMenu
          ContextLocation={columnContextMenuData}
          Column={columnContextData}
          IsInFavorites={columnContextDataExists}
          HandleColumnContext={handleContextHeaderItemSelected}
          onClose={handleColumnContextMenuClose}
          />
      )}
      
    </div>
    <Modal open={deleteShotModal}>
        <DeleteShot CurrentShot={selectedShot} DeleteShotResult={handleDeleteShotResult} />
      </Modal>
      <Modal open={moveShotModal}>
        <MoveShot
          CurrentSession={GetCurrentSession()}
          CurrentSetup={selectedSetup}
          CurrentShot={selectedShot}
          MoveShotResult={handleMoveShotResult}
        />
      </Modal>
  </div>
  );
}

export default ShotList;
